import router from '../services/router_service';
import commonController from '../controllers/common_controller';

router.once('route:common', commonController);
